// Theme entry — CSS is bundled via PostCSS, behaviours are wired below.
import "../css/index.css";

import { initThemeToggle } from './theme-toggle.js';
import { initClock } from './clock.js';
import { initMastheadParallax } from './masthead-parallax.js';
import { initReveal } from './reveal.js';
import { initMagnetic } from './magnetic.js';
import { initCursorDot } from './cursor-dot.js';
import { initReadingProgress } from './reading-progress.js';
import { initTOC } from './toc.js';
import { initMarginalia } from './marginalia.js';
import { initShare } from './share.js';
import { initMenu } from './menuOpen.js';
import { initYearsSince } from './years-since.js';
import { initVolume } from './volume.js';

const boot = () => {
    initMenu();
    initThemeToggle();
    initYearsSince();
    initVolume();
    initClock();
    initReveal();
    initShare();
    initCursorDot();

    if (document.querySelector('.gh-masthead')) {
        initMastheadParallax();
    }

    if (document.querySelector('[data-magnetic]')) {
        initMagnetic();
    }

    if (document.querySelector('[data-page="article"]')) {
        initReadingProgress();
        initTOC();
        initMarginalia();
    }
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
} else {
    boot();
}
